module.exports = "./img/desktop_logo.7b1bce4.png";